import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FullStory } from '@fullstory/browser';
import routes from 'routes';
import pages from 'pages';
import { useUser } from '../../../../hooks/useUser';

export default function OAuth2Authorize() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { userResult } = useUser();
  const hasRedirected = useRef(false);

  useEffect(() => {
    const paramKeys = ['client_id', 'redirect_uri', 'response_type', 'scope', 'state'];
    const queryString = paramKeys
      .filter((key) => searchParams.has(key))
      .map((key) => {
        const value = searchParams.get(key);
        return value ? `${key}=${encodeURIComponent(value)}` : '';
      })
      .join('&');

    if (!userResult || userResult?.loading || hasRedirected.current) return;
    hasRedirected.current = true;

    FullStory('trackEvent', {
      name: 'OAuth2 Authorization Redirect',
      properties: { user: userResult?.user },
    });

    if (userResult?.user) {
      datadogRum.addAction('sso-oauth2-redirect-authenticated');
      FullStory('trackEvent', {
        name: 'OAuth2 Authorization Redirect - Authenticated',
        properties: {},
      });
      window.location.href = `${routes.authorize}?${queryString}`;
    } else {
      datadogRum.addAction('sso-oauth2-redirect-unauthenticated');
      FullStory('trackEvent', {
        name: 'OAuth2 Authorization Redirect - Unauthenticated',
        properties: {},
      });
      navigate(`/${pages.LOGIN}?${searchParams}&redirect_to_oauth=true`);
    }
  }, [navigate, searchParams, userResult]);

  return null;
}
